<template>
<div>
<!--  扣除提示： 技术支持/主办单位设置-->
  <a-modal width="350px"
           v-model="visible"
           :footer="null"
           @cancel="handleClose">
    <div style="display: flex">
      <a-icon type="info-circle" theme="filled" style="color: #FAAD14;font-size: 20px"/>
      <div style="margin-left: 10px">
        <div style="font-weight: bold;color: #333333;margin-bottom: 10px">去除技术支持服务剩余7次</div>
        <div style="margin-bottom: 20px">本次使用将扣除 1 次，是否确认使用？</div>
      </div>
    </div>
    <div style="display: flex;justify-content: right">
      <a-button @click="handleClose">取消</a-button>
      <a-button type="primary" style="margin-left: 10px">确定</a-button>
    </div>
  </a-modal>
</div>
</template>

<script>
export default {
name: "DeductionPrompt",
  props:{
    visible:{
      type:Boolean
    }
  },
  methods:{
    handleClose(){
      let visible = false;
      this.$emit("closeDeductionPrompt", visible); //子组件向父组件传值（开关）
    },
  }
}
</script>

<style scoped>

</style>
